import { ExternalBankAccountStatus } from '@/types/externalAccounts';

export function generateExternalAccountStatusLabel(
  status: ExternalBankAccountStatus,
) {
  switch (status) {
    case ExternalBankAccountStatus.AWAITING_BANK_ADDRESS:
      return 'Awaiting Bank Address';
    case ExternalBankAccountStatus.AWAITING_BANK_NAME:
      return 'Awaiting Bank Code';
    case ExternalBankAccountStatus.AWAITING_CODE:
      return 'Awaiting Code';
    case ExternalBankAccountStatus.AWAITING_E_SIGN:
      return 'Awaiting ESign';
    case ExternalBankAccountStatus.DECLINED:
      return 'Declined';
    case ExternalBankAccountStatus.DELETED:
      return 'Deleted';
    case ExternalBankAccountStatus.PENDING:
      return 'Pending';
    case ExternalBankAccountStatus.SUBMITTED:
      return 'Submitted';
    case ExternalBankAccountStatus.VERIFIED:
      return 'Verified';
    default:
      return '';
  }
}
